import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const multipleSkuLabel = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "SKUs",
    description: {
      text: "Label for SKUs (stock keeping units). This label will be displayed right beside a list of SKUs.",
      img: "https://cdn.faire.com/fastly/89991bb147c83690d94c1a7228457fe3c9f4c0e77a6131f783011ad499eb585e.png",
    },
  });

export const expandButtonLabel = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "See All",
    description: {
      text: "Label for button expanding list of SKUs so that all of them become visible.",
      img: "https://cdn.faire.com/fastly/89991bb147c83690d94c1a7228457fe3c9f4c0e77a6131f783011ad499eb585e.png",
    },
  });

export const collapseButtonLabel = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "See Less",
    description: {
      text: "Label for button collapsing list of SKUs so less of them become visible.",
      img: "https://cdn.faire.com/fastly/3e91a372a379f10bcd316bedae7db97929fa0944257a572148036c1bb017bbcf.png",
    },
  });
